"use strict";
/*
 ## External Dependencies ##
 - jQuery ($)
 */

var Tooltip = require("app/shared/components/Tooltip/tooltip");
var cx = require("classnames");

var Prompt = React.createClass({
  propTypes: {
    autoClose: React.PropTypes.bool,
    buttonClasses: React.PropTypes.string,
    buttonText: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.node]),
    errorMsg: React.PropTypes.string,
    hideWarningIcon: React.PropTypes.bool,
    inputInstructions: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.node]),
    inputPlaceholder: React.PropTypes.string,
    isOpen: React.PropTypes.bool,
    onCancel: React.PropTypes.func,
    onConfirm: React.PropTypes.func,
    showTooltip: React.PropTypes.bool,
    text: React.PropTypes.string,
    title: React.PropTypes.string,
    tooltipTitle: React.PropTypes.string,
    type: React.PropTypes.string,
    warningText: React.PropTypes.string,
    cancelText: React.PropTypes.string,
    dismissable: React.PropTypes.bool,
    embed: React.PropTypes.string,
    overlayClose: React.PropTypes.bool
  },
  getDefaultProps: function () {
    return {
      type: "alert", //alert, confirm, prompt
      buttonClasses: "btn btn-primary",
      autoClose: true,
      isOpen: true,
      errorMsg: null,
      buttonText: "OK",
      text: "",
      inputPlaceholder: "",
      hideWarningIcon: false,
      warningText: null,
      inputInstructions: null,
      cancelText: "Cancelar",
      dismissable: true,
      overlayClose: true
    };
  },
  getInitialState: function() {
    return {
      closeAfterConfirm: false,
      inputValue: ""
    };
  },
  componentDidMount: function(){
    if (this.props.isOpen === true) {
      this.hidePageScrollbar();
    }
    this.focusMainButton();
  },
  componentDidUpdate: function (prevProps) {
    if (prevProps.isOpen === false && this.props.isOpen === true) {
      this.hidePageScrollbar();
      this.focusMainButton();
    }
  },
  componentWillUnmount: function() {
    this.showPageScrollbar();
  },
  focusMainButton: function(){
    if (!this.props.isOpen) {
      return;
    }
    setTimeout(function(){
      if (this.refs["main-button"]) {
        $(this.refs["main-button"]).focus();
      }
    }.bind(this), 100);
  },
  onChange: function(event) {
    this.setState({inputValue: event.target.value});
  },
  close: function () {
    if (this.props.onClose) {
      this.props.onClose(ReactDOM.findDOMNode(this));
    }
    this.showPageScrollbar();
  },
  onConfirm: function(e){
    this.setState({closeAfterConfirm:true});
    var inputValue = (this.props.type=="prompt") ? this.refs["prompt-input"] : null;
    if (this.props.onConfirm) {
      this.props.onConfirm(inputValue);
    }
    if (this.props.autoClose) {
      this.close();
    }
    this.stopEventPropagation(e);
  },
  onCancel: function(e){
    if(this.props.onCancel) {
      this.props.onCancel();
    }
    this.close();
    this.stopEventPropagation(e);
  },
  onKeyDown: function(e){
    if(e.which==13) {
      this.onConfirm(e);
    }
  },
  onClickOverlay: function(e) {
    if (this.props.overlayClose) {
      this.onCancel(e);
    }
  },
  showPageScrollbar: function() {
    var htmlElem = document.getElementsByTagName("html")[0];
    $(htmlElem).css({"overflow-y": "auto"});
  },
  hidePageScrollbar: function() {
    var htmlElem = document.getElementsByTagName("html")[0];
    $(htmlElem).css({"overflow-y": "hidden"});
  },
  stopEventPropagation: function (e) {
    e.stopPropagation();
  },

  decodeText: function() {
    var textArea = document.createElement("textarea");
    textArea.innerHTML = this.props.title;
    return textArea.value;
  },

  render: function(){
    if (!this.props.isOpen) {
      return (<div></div>);
    }
    var buttonClasses = cx(this.props.buttonClasses, "minw-100",
                            {"c-disabled": this.props.disabledConfirmButton,
                             "o-50": this.props.disabledConfirmButton});

    return (
      <div className="overlay" onClick={this.onClickOverlay}>
        <div ref="prompt" className="prompt" onClick={this.stopEventPropagation}>
          {
            this.props.dismissable ? (
              <button
                type="button"
                onClick={this.onCancel}
                className="close prompt-closeButton"
                data-dismiss="alert"
                aria-label="Close"
              >
                <span className="custom-glyphicon icon-close" aria-hidden="true" />
              </button>
            ) : null
          }
          <div className="text-center prompt-content">
            {(this.props.warningText)?<h2 className="c-888">{this.props.warningText}</h2> : null}
            {(this.props.title)?<h3 className="prompt-title ta-c" ref="title">{this.decodeText()}</h3> : null}
            {(this.props.text)?<p className="prompt-text">{this.props.text}</p> : null}
            {(this.props.embed)?<iframe src={this.props.embed} allowFullScreen frameBorder="0" width="560" height="315" /> : null}
            {this.props.children}
            {(this.props.errorMsg!=null) ? <div className="alert alert-danger prompt-alert c-666" role="alert" dangerouslySetInnerHTML={{__html: this.props.errorMsg }} /> : null}
            {(this.props.inputInstructions) ? <p className="prompt-inputSeparator"><span dangerouslySetInnerHTML={{__html: this.props.inputInstructions}}></span></p> : null}
            {(this.props.type=="prompt") ? <input type="text" ref="prompt-input" onKeyDown={this.onKeyDown} className="prompt-input form-control" placeholder={this.props.inputPlaceholder} value={this.state.inputValue} onChange={this.onChange} /> : null}
          </div>
          <div className="prompt-contentSeparator text-center row">
            {
              (this.props.type != "alert" && this.props.dismissable) ? (
                <a href="javascript:void(0);" className="btn btn-default mr-20 minw-100" ref="cancel-button" onClick={this.onCancel} key="1">{this.props.cancelText}</a>
              ) : null
            }
            <Tooltip bottom title={this.props.showTooltip ? this.props.tooltipTitle : ""}>
              <button type="button" ref="main-button" className={buttonClasses} onClick={(!this.props.disabledConfirmButton) && this.onConfirm} >
                {this.props.buttonText}
              </button>
            </Tooltip>
          </div>
        </div>
      </div>
    );
  }
});

module.exports = Prompt;



// WEBPACK FOOTER //
// ./app/shared/components/Prompt/prompt.jsx